import {useSelector} from "react-redux";
import {useLocation} from "react-router-dom";

import {selectAllPositionPermissions, selectCurrentUser} from "../../../../../slices/UserSlice";
import {IT_MANAGERS_IDS} from "../../../../../utilities/generalConstants.js/generalConstants";

const useLocationPermission = ({location} = {}) => {
  const currentLocation = useLocation();
  const allPermissions = useSelector(selectAllPositionPermissions);
  const user = useSelector(selectCurrentUser);

  //   useEffect(() => {}, [user?.userId]);

  const isITManager = IT_MANAGERS_IDS.includes(user?.id);

  const url = location || currentLocation.pathname || "";

  const routeParts = url.split("/");

  const isTopRoute = routeParts?.length <= 3;
  const subRoute = "/" + (isTopRoute ? "" : routeParts?.slice(3).join("/"));

  const isAllowed = Boolean(isITManager || (subRoute && allPermissions[subRoute]));
  const isNotAllowed = !isAllowed;

  return {isAllowed, isNotAllowed};
};

export default useLocationPermission;
